exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scd-report[data-v-449a8e25]{min-width:1100px}.scd-report td[data-v-449a8e25],.scd-report th[data-v-449a8e25]{padding:.35rem .5rem;vertical-align:middle;white-space:nowrap}.scd-report thead th[data-v-449a8e25]{background-color:#d9ead3;text-align:center;vertical-align:middle}.scd-status-cell[data-v-449a8e25]{font-weight:600}.scd-total-row td[data-v-449a8e25]{background-color:#f2f2f2;font-weight:600}.scd-grand-total-row td[data-v-449a8e25]{background-color:#d0cece;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-449a8e25","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/StockCoverDays/StockCoverDaysReport.vue
// module id = 1078
// module chunks = 0